import { styled } from '../theme';

const TableRow = styled('tr')(({ theme }) => ({
    height: '70px',
    borderBottom: theme.border.tableRowSeparator,
    fontFamily: theme.typography.fontFamily,
    fontSize: '1.6rem',
}));

export default TableRow;
